import React from 'react';

import Spinner from 'shared/Icon/Spinner';
import theme from 'styles/theme';

import { IButton } from '../index';
import { ButtonAlign, ButtonSizes } from '../Enum';

import { ButtonSpinnerLoaderComponent } from './styles';

export interface IButtonSpinner extends IButton {
  isLoading?: boolean;
}

const ButtonSpinnerLoader: React.FC<IButtonSpinner> = ({
  size = ButtonSizes.DEFAULT,
  align = ButtonAlign.CENTER,
  color = theme.colors.primary,
  isLoading = false,
  disabled,
  children,
  ...rest
}) => {
  return (
    <ButtonSpinnerLoaderComponent
      id={
        children?.toString().toUpperCase().includes('PROSSEGUIR')
          ? 'nextButton'
          : ''
      }
      className={
        children?.toString().toUpperCase().includes('PROSSEGUIR')
          ? 'nextButton'
          : ''
      }
      size={size}
      align={align}
      color={color}
      disabled={disabled || isLoading}
      isLoading={isLoading}
      {...rest}
    >
      {isLoading ? <Spinner size={size} color={color} /> : <p>{children}</p>}
    </ButtonSpinnerLoaderComponent>
  );
};

export default ButtonSpinnerLoader;
